import React from 'react'
import './CoperateContent.scss'

import coperatePic from '../../../assets/Pictures/Corperate.png'

export default function CoperateContent() {
  return (
    <div className='coperateContentAr'>
      <div className="container">
        <div className="row">
          <div className="right">
            <h1 className="coperateContentTitle">
              المؤسسية
            </h1>
            <h2 className="coperateContentSubtitle">
              نحن شركات هندسية واستشارية وتجارة دولية تعمل في قطاع صناعة الصلب والبناء. نشاط شركاتنا بشكل رئيسي في تركيا وعمان.
              <br />
              <br />
                ”Vigor Global Energy company “VGE شرکة
                و مقرها إسطنبول،ترکیا و شرکة       
                <br />
                ”Global Energy Investment “GEI
                و مقرها مسقط ، عمان.
                <br /><br />
              شركاتنا في قطاع الصلب هي الممثل الرسمي لمجمع كافير للصلب (أحد أكبر منتجي منتجات الصلب في الشرق الأوسط) في تركيا وعمان والدول الأفريقية. نحن نعمل بشكل وثيق مع شركات التصنيع والبناء الرائدة في تركيا وعمان ودول أخرى لتصدير منتجات عالية الجودة من الحديد والصلب مثل قضبان الأسلاك وسبائك الصلب وقضبان التسليح ذات الدرجة الخاصة والشهادات الأوروبية إلى العديد من المصانع المستخدمة كمواد خام مادة.
              <br />
              <br />
              {/* تعمل شرکة ..... تعمل شركة ..... في مصنع النفايات الصلبة الصلبة، وإعادة التدوير وتحويل النفايات إلى قطاع محطات الطاقة، بالتعاون الوثيق مع.......( إحدى الشركات الرائدة في هذا القطاع ) نحن نولد طاقة مستدامة بيئيًا من النفايات عن طريق تحويل النفايات البلاستيكية إلى وقود وتحويل النفايات إلى غازات قابلة للاحتراق بتكنولوجيا مربحة  */}
              <br />
            </h2>
          </div>
          <div className="left">
            <img src={coperatePic} alt="coperatePic" />
          </div>
        </div>
      </div>
    </div>
  )
}
